var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_6029_20403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.21 1.05H8.84V0H7.37V1.05H4.63V0H3.16V1.05H1.79C0.8 1.05 0 1.85 0 2.84V10.21C0 11.2 0.8 12 1.79 12H10.21C11.2 12 12 11.2 12 10.21V2.84C12 1.85 11.2 1.05 10.21 1.05ZM1.79 2.53H3.16V3.37H4.63V2.53H7.37V3.37H8.84V2.53H10.21C10.38 2.53 10.53 2.67 10.53 2.85V4.22H1.47V2.85C1.47 2.68 1.61 2.53 1.79 2.53ZM10.21 10.53H1.79C1.62 10.53 1.47 10.39 1.47 10.21V5.68H10.52V10.21C10.52 10.38 10.38 10.53 10.2 10.53H10.21Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6029_20403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarBlack);
export default __webpack_public_path__ + "static/media/icon-calendar-black.e5e666a4f3a65f2dde73d9d8b4e33ae0.svg";
export { ForwardRef as ReactComponent };